// Inline (not <img>) so `fill="currentColor"` inherits the surrounding text colour.
// Same paths as public/jamora-icon.svg.
export default function JamoraIcon({ size = 16, className, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M9.2 2H14.5C15.55 2 16.4 2.85 16.4 3.9V7.2C13.25 8.15 11.55 10.2 10 13.25C8.45 16.3 6.65 17.1 3.9 17.1H3C1.9 17.1 1 16.2 1 15.1V10.5C1 9.4 1.9 8.5 3 8.5H7.2V4C7.2 2.9 8.1 2 9.2 2Z" />
      <path d="M18.1 8.5H21C22.1 8.5 23 9.4 23 10.5V15.1C23 16.2 22.1 17.1 21 17.1H16.4V21.4C16.4 22.5 15.5 23.4 14.4 23.4H9.2C8.1 23.4 7.2 22.5 7.2 21.4V18.3C10.25 17.05 11.75 15.5 13.4 12.35C14.8 9.7 16.5 8.5 18.1 8.5Z" />
    </svg>
  );
}
